import styled from "styled-components";

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(8px);
`;

export const Modal = styled.div`
  width: 420px;
  max-width: 90vw;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.28);
  padding: 20px 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
`;

export const ReadOnlyBox = styled.div`
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  color: #0f172a;
`;

export const Input = styled.input`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  outline: none;
  background: #f9fafb;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.35);
    background: #ffffff;
  }
`;

export const BoolRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 6px;
  flex-wrap: wrap;
`;

export const BoolItem = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #0f172a;
  background: #f8fafc;
  border-radius: 999px;
  padding: 6px 10px;
  border: 1px solid #e2e8f0;
  cursor: pointer;

  input {
    cursor: pointer;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
`;

export const Button = styled.button<{ variant?: "primary" | "ghost" }>`
  min-width: 88px;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: ${({ variant }) =>
    variant === "primary" ? "none" : "1px solid #e2e8f0"};
  background: ${({ variant }) =>
    variant === "primary" ? "#2563eb" : "#ffffff"};
  color: ${({ variant }) => (variant === "primary" ? "#ffffff" : "#0f172a")};

  &:hover {
    opacity: 0.92;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
